import { MatDialogRef } from '@angular/material/dialog';
import { ResiliationConsultantService } from './../services/resiliation-consultant.service';
import { Component, inject, signal } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoading } from 'omnium-ui/loading';
import { OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
  selector: 'app-annulation-resiliation-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule, OuiLoading],
  templateUrl: './annulation-resiliation-dialog.component.html',
  styleUrl: './annulation-resiliation-dialog.component.scss',
})
export class AnnulationResiliationDialogComponent {
  private readonly resilaitionService = inject(ResiliationConsultantService);
  private readonly snackbarService = inject(OuiSnackbarService);
  private readonly dialogRef = inject(MatDialogRef<AnnulationResiliationDialogComponent>);

  readonly isLoading = signal<boolean>(false);

  async cancelResiliation() {
    this.isLoading.set(true);
    try {
      await this.resilaitionService.cancelResiliation();

      this.snackbarService.open(
        "L'annulation de votre demande de résiliation a bien été prise en compte",
        'success'
      );

      this.dialogRef.close(true);
    } catch (error) {
      console.error(error);
      this.snackbarService.open(
        "Une erreur est survenue durant l'annulation de votre demande de résiliaiton",
        'error'
      );
    }
    this.isLoading.set(false);
  }
}
